import { render, staticRenderFns } from "./DemoFormLayoutVerticalFormWithIcons.vue?vue&type=template&id=1b347c5a"
import script from "./DemoFormLayoutVerticalFormWithIcons.vue?vue&type=script&lang=js"
export * from "./DemoFormLayoutVerticalFormWithIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports